import { useState } from "react";
import { chooseAdMeasurement, isAdOptedOut } from "../../lib/adMeasurement";

/** ADR-0058: the Privacy page's switch for ad measurement with X, on this browser. */
export function AdMeasurementChoice() {
  const [optedOut] = useState(() => typeof document !== "undefined" && isAdOptedOut(document.cookie));
  return <AdMeasurementChoiceView optedOut={optedOut} onChoose={chooseAdMeasurement} />;
}

/** The switch, presentational (server-rendered in the unit tests). */
export function AdMeasurementChoiceView({ optedOut, onChoose }: { optedOut: boolean; onChoose(optOut: boolean): void }) {
  return (
    <section data-testid="ad-measurement-choice">
      <h2>Your ad measurement choice</h2>
      <p data-testid="ad-measurement-state">{optedOut ? "Ad measurement with X is off on this browser." : "Ad measurement with X is allowed on this browser, unless you are in a region where we never use it (see section 6)."}</p>
      <p>
        <button type="button" className="btn" onClick={() => onChoose(!optedOut)} data-testid="ad-measurement-toggle">
          {optedOut ? "Allow ad measurement" : "Turn off ad measurement"}
        </button>
      </p>
    </section>
  );
}
